export default __webpack_public_path__ + "static/media/Linkedin-Heart.7ffe4395.png";